import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TheNavbar } from "./Navbar";
import { TheFooterFunction } from "./Footer";

export function Quiz() {
  const [answers, setAnswers] = useState({});
  const navigate = useNavigate();

  const handleOptionChange = (question, value) => {
    setAnswers({ ...answers, [question]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const tally = { A: 0, B: 0, C: 0, D: 0 };
    Object.values(answers).forEach((answer) => {
      tally[answer] += 1;
    });

    const majorKey = Object.keys(tally).reduce((a, b) =>
      tally[a] > tally[b] ? a : b
    );
    const majorMap = {
      A: "Business",
      B: "Engineering",
      C: "Arts and Humanities",
      D: "Medical",
    };
    const major = majorMap[majorKey];

    navigate("/results", { state: { major } });
  };

  return (
    <main>
      <TheNavbar />
      <div className="container bg-subtle">
        <form onSubmit={handleSubmit}>
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 text-center">
              <h1 className="mb-4">
                <img className="body-logo" src="img/logo.png" alt="logo" />
                <span className="quiz-title">Major Quiz</span>
              </h1>
            </div>
          </div>

          <div className="row">
            <div className="col-2"></div>
            <div className="col-8">
              <div className="about container custom-bg-color py-4">
                <h2>About</h2>
                <p>
                  This major quiz will encompass your interests, personality,
                  salary desires, difficulty of classes preferred, work style,
                  and class size. Based on your response, this quiz will suggest
                  relevant majors and potential career paths with detailed
                  information.
                </p>
              </div>
              {/* Question 1 */}
              <div className="question container custom-bg-color py-4">
                <h2>Question 1 of 10</h2>
                <p>What type of problem-solving skills do you enjoy most?</p>
                <label htmlFor="q1a">
                  <input
                    type="radio"
                    id="q1a"
                    name="q1"
                    value="A"
                    onChange={() => handleOptionChange("q1", "A")}
                  />{" "}
                  Analyzing market trends and financial data
                </label>
                <label htmlFor="q1b">
                  <input
                    type="radio"
                    id="q1b"
                    name="q1"
                    value="B"
                    onChange={() => handleOptionChange("q1", "B")}
                  />{" "}
                  Designing structures or systems
                </label>
                <label htmlFor="q1c">
                  <input
                    type="radio"
                    id="q1c"
                    name="q1"
                    value="C"
                    onChange={() => handleOptionChange("q1", "C")}
                  />{" "}
                  Interpreting literature or exploring artistic expression
                </label>
                <label htmlFor="q1d">
                  <input
                    type="radio"
                    id="q1d"
                    name="q1"
                    value="D"
                    onChange={() => handleOptionChange("q1", "D")}
                  />{" "}
                  Diagnosing and treating illnesses or ailments
                </label>
              </div>
              {/* Question 2 */}
              <div className="question container custom-bg-color py-4">
                <h2>Question 2 of 10</h2>
                <p>Which of the following subjects interests you the most?</p>
                <label htmlFor="q2a">
                  <input
                    type="radio"
                    id="q2a"
                    name="q2"
                    value="A"
                    onChange={() => handleOptionChange("q2", "A")}
                  />{" "}
                  Economics or business management
                </label>
                <label htmlFor="q2b">
                  <input
                    type="radio"
                    id="q2b"
                    name="q2"
                    value="B"
                    onChange={() => handleOptionChange("q2", "B")}
                  />{" "}
                  Physics or mathematics
                </label>
                <label htmlFor="q2c">
                  <input
                    type="radio"
                    id="q2c"
                    name="q2"
                    value="C"
                    onChange={() => handleOptionChange("q2", "C")}
                  />{" "}
                  History or philosophy
                </label>
                <label htmlFor="q2d">
                  <input
                    type="radio"
                    id="q2d"
                    name="q2"
                    value="D"
                    onChange={() => handleOptionChange("q2", "D")}
                  />{" "}
                  Biology or anatomy
                </label>
              </div>
              {/* Question 3 */}
              <div className="question container custom-bg-color py-4">
                <h2>Question 3 of 10</h2>
                <p>How do you prefer to spend your free time?</p>
                <label htmlFor="q3a">
                  <input
                    type="radio"
                    id="q3a"
                    name="q3"
                    value="A"
                    onChange={() => handleOptionChange("q3", "A")}
                  />{" "}
                  Networking and attending business events
                </label>
                <label htmlFor="q3b">
                  <input
                    type="radio"
                    id="q3b"
                    name="q3"
                    value="B"
                    onChange={() => handleOptionChange("q3", "B")}
                  />{" "}
                  Working on DIY projects or tinkering with technology
                </label>
                <label htmlFor="q3c">
                  <input
                    type="radio"
                    id="q3c"
                    name="q3"
                    value="C"
                    onChange={() => handleOptionChange("q3", "C")}
                  />{" "}
                  Visiting museums or attending cultural events
                </label>
                <label htmlFor="q3d">
                  <input
                    type="radio"
                    id="q3d"
                    name="q3"
                    value="D"
                    onChange={() => handleOptionChange("q3", "D")}
                  />{" "}
                  Volunteering at hospitals or clinics
                </label>
              </div>
              {/* Question 4 */}
              <div className="question container custom-bg-color py-4">
                <h2>Question 4 of 10</h2>
                <p>What kind of workplace environment suits you best?</p>
                <label htmlFor="q4a">
                  <input
                    type="radio"
                    id="q4a"
                    name="q4"
                    value="A"
                    onChange={() => handleOptionChange("q4", "A")}
                  />{" "}
                  Competitive and results-oriented
                </label>
                <label htmlFor="q4b">
                  <input
                    type="radio"
                    id="q4b"
                    name="q4"
                    value="B"
                    onChange={() => handleOptionChange("q4", "B")}
                  />{" "}
                  Structured and technical
                </label>
                <label htmlFor="q4c">
                  <input
                    type="radio"
                    id="q4c"
                    name="q4"
                    value="C"
                    onChange={() => handleOptionChange("q4", "C")}
                  />{" "}
                  Collaborative and creative
                </label>
                <label htmlFor="q4d">
                  <input
                    type="radio"
                    id="q4d"
                    name="q4"
                    value="D"
                    onChange={() => handleOptionChange("q4", "D")}
                  />{" "}
                  Empathetic and patient-focused
                </label>
              </div>
              {/* Question 5 */}
              <div className="question container custom-bg-color py-4">
                <h2>Question 5 of 10</h2>
                <p>Which of the following skills do you value the most?</p>
                <label htmlFor="q5a">
                  <input
                    type="radio"
                    id="q5a"
                    name="q5"
                    value="A"
                    onChange={() => handleOptionChange("q5", "A")}
                  />{" "}
                  Negotiation and persuasion
                </label>
                <label htmlFor="q5b">
                  <input
                    type="radio"
                    id="q5b"
                    name="q5"
                    value="B"
                    onChange={() => handleOptionChange("q5", "B")}
                  />{" "}
                  Problem-solving and critical thinking
                </label>
                <label htmlFor="q5c">
                  <input
                    type="radio"
                    id="q5c"
                    name="q5"
                    value="C"
                    onChange={() => handleOptionChange("q5", "C")}
                  />{" "}
                  Communication and empathy
                </label>
                <label htmlFor="q5d">
                  <input
                    type="radio"
                    id="q5d"
                    name="q5"
                    value="D"
                    onChange={() => handleOptionChange("q5", "D")}
                  />{" "}
                  Attention to detail and precision
                </label>
              </div>
              {/* Question 6 */}
              <div className="question container custom-bg-color py-4">
                <h2>Question 6 of 10</h2>
                <p>When faced with a challenge, what's your approach?</p>
                <label htmlFor="q6a">
                  <input
                    type="radio"
                    id="q6a"
                    name="q6"
                    value="A"
                    onChange={() => handleOptionChange("q6", "A")}
                  />{" "}
                  Formulating a strategic plan
                </label>
                <label htmlFor="q6b">
                  <input
                    type="radio"
                    id="q6b"
                    name="q6"
                    value="B"
                    onChange={() => handleOptionChange("q6", "B")}
                  />{" "}
                  Breaking it down into manageable steps
                </label>
                <label htmlFor="q6c">
                  <input
                    type="radio"
                    id="q6c"
                    name="q6"
                    value="C"
                    onChange={() => handleOptionChange("q6", "C")}
                  />{" "}
                  Seeking inspiration from art or literature
                </label>
                <label htmlFor="q6d">
                  <input
                    type="radio"
                    id="q6d"
                    name="q6"
                    value="D"
                    onChange={() => handleOptionChange("q6", "D")}
                  />{" "}
                  Considering various diagnoses or treatment options
                </label>
              </div>
              {/* Question 7 */}
              <div className="question container custom-bg-color py-4">
                <h2>Question 7 of 10</h2>
                <p>Which type of innovation excites you the most?</p>
                <label htmlFor="q7a">
                  <input
                    type="radio"
                    id="q7a"
                    name="q7"
                    value="A"
                    onChange={() => handleOptionChange("q7", "A")}
                  />{" "}
                  Disruptive business models
                </label>
                <label htmlFor="q7b">
                  <input
                    type="radio"
                    id="q7b"
                    name="q7"
                    value="B"
                    onChange={() => handleOptionChange("q7", "B")}
                  />{" "}
                  Technological advancements
                </label>
                <label htmlFor="q7c">
                  <input
                    type="radio"
                    id="q7c"
                    name="q7"
                    value="C"
                    onChange={() => handleOptionChange("q7", "C")}
                  />{" "}
                  Creative expressions in art or design
                </label>
                <label htmlFor="q7d">
                  <input
                    type="radio"
                    id="q7d"
                    name="q7"
                    value="D"
                    onChange={() => handleOptionChange("q7", "D")}
                  />{" "}
                  Medical breakthroughs and treatments
                </label>
              </div>
              {/* Question 8 */}
              <div className="question container custom-bg-color py-4">
                <h2>Question 8 of 10</h2>
                <p>What type of reading material do you enjoy?</p>
                <label htmlFor="q8a">
                  <input
                    type="radio"
                    id="q8a"
                    name="q8"
                    value="A"
                    onChange={() => handleOptionChange("q8", "A")}
                  />{" "}
                  Business magazines or financial reports
                </label>
                <label htmlFor="q8b">
                  <input
                    type="radio"
                    id="q8b"
                    name="q8"
                    value="B"
                    onChange={() => handleOptionChange("q8", "B")}
                  />{" "}
                  Scientific journals or technical manuals
                </label>
                <label htmlFor="q8c">
                  <input
                    type="radio"
                    id="q8c"
                    name="q8"
                    value="C"
                    onChange={() => handleOptionChange("q8", "C")}
                  />{" "}
                  Novels or poetry
                </label>
                <label htmlFor="q8d">
                  <input
                    type="radio"
                    id="q8d"
                    name="q8"
                    value="D"
                    onChange={() => handleOptionChange("q8", "D")}
                  />{" "}
                  Medical research papers or case studies
                </label>
              </div>
              {/* Question 9 */}
              <div className="question container custom-bg-color py-4">
                <h2>Question 9 of 10</h2>
                <p>What kind of projects do you find most fulfilling?</p>
                <label htmlFor="q9a">
                  <input
                    type="radio"
                    id="q9a"
                    name="q9"
                    value="A"
                    onChange={() => handleOptionChange("q9", "A")}
                  />{" "}
                  Launching a new business venture
                </label>
                <label htmlFor="q9b">
                  <input
                    type="radio"
                    id="q9b"
                    name="q9"
                    value="B"
                    onChange={() => handleOptionChange("q9", "B")}
                  />{" "}
                  Designing and building prototypes
                </label>
                <label htmlFor="q9c">
                  <input
                    type="radio"
                    id="q9c"
                    name="q9"
                    value="C"
                    onChange={() => handleOptionChange("q9", "C")}
                  />{" "}
                  Producing artistic works or performances
                </label>
                <label htmlFor="q9d">
                  <input
                    type="radio"
                    id="q9d"
                    name="q9"
                    value="D"
                    onChange={() => handleOptionChange("q9", "D")}
                  />{" "}
                  Contributing to medical research or patient care
                </label>
              </div>
              {/* Question 10 */}
              <div className="question container custom-bg-color py-4">
                <h2>Question 10 of 10</h2>
                <p>How do you envision your future career impacting society?</p>
                <label htmlFor="q10a">
                  <input
                    type="radio"
                    id="q10a"
                    name="q10"
                    value="A"
                    onChange={() => handleOptionChange("q10", "A")}
                  />{" "}
                  Creating jobs and driving economic growth
                </label>
                <label htmlFor="q10b">
                  <input
                    type="radio"
                    id="q10b"
                    name="q10"
                    value="B"
                    onChange={() => handleOptionChange("q10", "B")}
                  />{" "}
                  Innovating new technologies for advancement
                </label>
                <label htmlFor="q10c">
                  <input
                    type="radio"
                    id="q10c"
                    name="q10"
                    value="C"
                    onChange={() => handleOptionChange("q10", "C")}
                  />{" "}
                  Enriching culture and promoting understanding
                </label>
                <label htmlFor="q10d">
                  <input
                    type="radio"
                    id="q10d"
                    name="q10"
                    value="D"
                    onChange={() => handleOptionChange("q10", "D")}
                  />{" "}
                  Improving health outcomes and saving lives
                </label>
              </div>
              <button type="submit" className="btn btn-light submit-button">
                Submit
              </button>
            </div>
            <div className="col-2"></div>
          </div>
        </form>
      </div>
      <TheFooterFunction />
    </main>
  );
}
